import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import * as createAccessPoint from 'store/actions/accessPoints/createAccessPoint';
import * as fetchAccessPoints from 'store/actions/accessPoints/fetchAccessPoints';
import * as updateAccessPoint from 'store/actions/accessPoints/updateAccessPoint';
import utils from 'helpers/utils';

function* fetchAccessPointsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/access-points`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchAccessPoints.fetchAccessPointsSuccess(response));
    } catch (error) {
        yield put(fetchAccessPoints.fetchAccessPointsFailure(error));
    }
}

function* fetchAccessPointAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        ...query
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/access-points/${ id }`;

        const response = yield apiClient.read(url, query);

        yield put(fetchAccessPoints.fetchAccessPointSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(fetchAccessPoints.fetchAccessPointFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* failureMessage({ payload }) {
    const { message } = payload.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

function* createAccessPointAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/access-points`;

        const response = yield apiClient.create(url, values);

        yield put(createAccessPoint.createAccessPointSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(createAccessPoint.createAccessPointFailure(error));

        if (utils.isFunction(onError)) {
            yield onError();
        }
    }
}

function* updateAccessPointAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/access-points/${ id }`;

        const response = yield apiClient.patch(url, values);

        yield put(updateAccessPoint.updateAccessPointSuccess(response));
        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(updateAccessPoint.updateAccessPointFailure(error));

        if (utils.isFunction(onError)) {
            yield onError();
        }
    }
}

export default function* accessPointsSagas() {
    yield [
        takeEvery(types.CREATE_ACCESS_POINT, createAccessPointAsync),
        takeEvery(types.FETCH_ACCESS_POINTS, fetchAccessPointsAsync),
        takeEvery(types.FETCH_ACCESS_POINT, fetchAccessPointAsync),
        takeEvery(types.UPDATE_ACCESS_POINT, updateAccessPointAsync),

        takeEvery(types.CREATE_ACCESS_POINT_FAILURE, failureMessage),
        takeEvery(types.FETCH_ACCESS_POINT_FAILURE, failureMessage),
        takeEvery(types.FETCH_ACCESS_POINTS_FAILURE, failureMessage),
        takeEvery(types.UPDATE_ACCESS_POINT_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/access-points/accessPointsSagas.js